import $ from 'jquery';

export default function () {
  $('.lightgallery').lightGallery();
}
